const axios = require('axios'),
    { rest } = require('./rest')


export const userService = {
    login,
    logout,
}


function login(username, password) {
    const body = { username, password }

    return axios.post(rest.REST_DOMAIN + '/auth',
        body,
        {
            headers: { Authorization: rest.getBearer() },
            responseEncoding: 'utf8',
            responseType: 'json',
        })
        .then(handleResponse)
        .then(data => {
            // login successful if there's a jwt token in the response
            if (data.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                data.user.token = data.token
                data.user.status = 'loggedIn'
                data.user.ghost = false
                data.user.id = data.user._id
                delete data.user._id

                localStorage.setItem('user', JSON.stringify(data.user))
            }
            return data
        })
}


function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user')
}


function handleResponse(response) {
    const data = response.data
    if (response.status >= 400 || !data.success) {
        if (response.status === 401) {
            // auto logout if 401 response returned from api
            logout()
            //location.reload(true);
        }

        const error = (data && (data.message || data.error)) || response.statusText
        return Promise.reject(error)
    } else {
        return data.user
    }
}